import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {GDriveItem} from '../__generated__/resolvers-types';

export const GET_GDRIVE_CONTENT_QUERY = gql`
  query GetGDriveContentQuery($folderId: String!) {
    getGDriveContent(folderId: $folderId) {
      id
      name
      mimeType
      webViewLink
      isFolder
      children {
        id
        name
        mimeType
        isFolder
      }
    }
  }
`;

export default function useGetGDriveContent(folderId?: string): GDriveItem | undefined {
  const {data} = useQuery<{getGDriveContent: GDriveItem}>(GET_GDRIVE_CONTENT_QUERY, {
    skip: !folderId,
    variables: {folderId},
  });

  return data?.getGDriveContent;
}
